module.exports = __webpack_public_path__ + "static/media/ios-trophy.18ebe495.svg";